import React, { useContext, useEffect, useState } from "react";
import { SidebarProps } from "react-sidebar";
import IGetOrderDTO from "../../../models/DTO/IGetOrderDTO";
import IOnQBOCreateInvoiceDTO from "../../../models/DTO/IOnQBOCreateInvoiceDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IOrder from "../../../models/IOrder";
import IShipment_GroupUI from "../../../models/IShipment_GroupUI";
import OwButton from "../../shared/OwButton/OwButton";
import OwTranslate from "../../shared/OwTranslate/OwTranslate";
import { QBOInvoiceActions } from "../../shared/QBOInvoiceActions/QBOInvoiceActions";
import { QuickBooksOnlineInvoiceSidebar } from "../../shared/QuickBooksOnlineInvoiceSidebar/QuickBooksOnlineInvoiceSidebar";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import SupplierContext from "../../../contexts/SupplierContext";
import { SocketContext } from "../../../contexts/SocketContext";
import * as _ from "lodash-es";
import UserContext from "../../../contexts/UserContext";
import IQBODownloadCreateInvoiceJsonDTO from "../../../models/QuickBooks Online/IQBODownloadCreateInvoiceJsonDTO";
import IQBOOnDownloadCreateInvoiceJsonDTO from "../../../models/QuickBooks Online/IQBOOnDownloadCreateInvoiceJsonDTO";
import UIService from "../../../services/UIService";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import UiContext from "../../../contexts/UiContext";

type Props = {
    order: IOrder;
    viewQBOInvoice: () => void;
    deleteQBOInvoice: () => void;
    voidQBOInvoice: () => void;
    createQBOInvoice: (shipping_cost: number, invoice_date: string, ship_via: string, tracking_no: string, ship_date: string) => void;
    active: boolean;
    reloadOrderFn: () => void;
};

export const OrderCreateQBOInvoice: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const onDownloadJson = (data: IQBOOnDownloadCreateInvoiceJsonDTO) => {
        UIService.downloadDataFile(data.fileData, `qbo-json-invoice-data-${props.order.name}.json`, "application/json");
    };

    const onCreateInvoice = (data: IOnQBOCreateInvoiceDTO) => {
        props.reloadOrderFn();
    };

    const sockets: IUiSocketSetup[] = [
        { endpoint: EndpointsEnum.QBOOnCreateInvoice, fn: onCreateInvoice },
        { endpoint: EndpointsEnum.QBOOnDownloadCreateInvoiceJson, fn: onDownloadJson },
    ];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        return () => {
            for (const _socket of sockets) {
                socket.off(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const cancelFn = () => {
        uiContext.setSidebarComponent(null);
        uiContext.toggleSidebar(false);
    };

    const saveFn = (shipmentGroup: IShipment_GroupUI, invoiceDate: string, shipVia: string, trackingNo: string, shipDate: string) => {
        const { shipping_cost } = shipmentGroup;

        props.createQBOInvoice(shipping_cost, invoiceDate, shipVia, trackingNo, shipDate);
    };

    const createInvoice = () => {
        const shipmentGroup: any = {};

        const component = (
            <QuickBooksOnlineInvoiceSidebar
                cancelFn={cancelFn}
                saveFn={saveFn}
                shipmentGroup={shipmentGroup}
                order={props.order}
                notifyFn={uiContext.notifyFn}
                socket={socket}
            />
        );

        uiContext.setSidebarComponent(component);
        uiContext.toggleSidebar(true);
    };

    const downloadJson = () => {
        const data: IQBODownloadCreateInvoiceJsonDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            orderGuid: props.order.guid,
        };

        socket.emit(EndpointsEnum.QBODownloadCreateInvoiceJson, data);
    };

    return (
        <div className={"OrderCreateQBOInvoice text-end d-print-none"}>
            <fieldset className={"no-wrap "}>
                <legend>
                    <OwTranslate defaultMessage={"quickbooks_online"} id={"quickbooks_online"} />
                </legend>
                {props.order?.qbo_EntityId ? (
                    <div>
                        <QBOInvoiceActions
                            active={props.active}
                            disabled={props.active}
                            viewFn={props.viewQBOInvoice}
                            deleteFn={props.deleteQBOInvoice}
                            voidFn={props.voidQBOInvoice}
                            fieldsetClassName={"w-auto"}
                        />
                    </div>
                ) : (
                    <>
                        <OwButton
                            leftIconClass={"fas fa-plus"}
                            title={"create_invoice"}
                            fn={createInvoice}
                            active={props.active}
                            disableOnActive={true}
                        />
                    </>
                )}
                {uiContext.showHiddenFeatures ? <OwButton title={"download_json"} fn={downloadJson} /> : null}
            </fieldset>
        </div>
    );
};
